export function buildStockOperations({
	originalItems,
	currentItems,
	removedItemIds,
	newItems,
}: {
	// Full original stock items from the loaded lot.
	originalItems: Array<{
		id: string
		name: string
		maxQuantity: number
		soldQuantity: number
	}>
	// Edited existing items still present in the form (removed ones excluded).
	currentItems: Array<{ id: string; name: string; maxQuantity: number }>
	removedItemIds: string[]
	newItems: Array<{ name: string; maxQuantity: number }>
}) {
	const originalById = new Map(originalItems.map((i) => [i.id, i]))
	const removedSet = new Set(removedItemIds)

	const renameItems: Array<{ id: string; name: string }> = []
	const setMaxQuantity: Array<{ id: string; maxQuantity: number }> = []

	for (const item of currentItems) {
		if (removedSet.has(item.id)) continue
		const original = originalById.get(item.id)
		if (!original) continue

		const trimmed = item.name.trim()
		// Rename only while nothing sold; the guard mirrors the slot rule.
		if (
			original.soldQuantity === 0 &&
			trimmed &&
			trimmed !== original.name
		) {
			renameItems.push({ id: item.id, name: trimmed })
		}
		if (item.maxQuantity !== original.maxQuantity) {
			setMaxQuantity.push({ id: item.id, maxQuantity: item.maxQuantity })
		}
	}

	const addItems = newItems
		.filter((i) => i.name.trim())
		.map((i) => ({ name: i.name.trim(), maxQuantity: i.maxQuantity }))

	return {
		addItems,
		renameItems,
		removeItemIds: removedItemIds,
		setMaxQuantity,
	}
}
